import { createAsyncThunk } from "@reduxjs/toolkit";
import http from "../utils/axios";

export const registerUser = createAsyncThunk(
    "users/register",
    async (body, thunkAPI) => {
        try {
            return (await http.post(`/api/users/register`, body)).data;
        } catch (err) {
            return thunkAPI.rejectWithValue(
                err.response.data.message || err.message
            );
        }
    }
);

export const loginUser = createAsyncThunk(
    "users/login",
    async (body, thunkAPI) => {
        try {
            return (await http.post(`/api/users/login`, body)).data;
        } catch (err) {
            return thunkAPI.rejectWithValue(
                err.response.data.message || err.message
            );
        }
    }
);

export const logoutUser = createAsyncThunk(
    "users/logout",
    async (body, thunkAPI) => {
        try {
            return (await http.post(`/api/users/logout`, body)).data;
        } catch (err) {
            return thunkAPI.rejectWithValue(
                err.response.data.message || err.message
            );
        }
    }
);

export const updateUser = createAsyncThunk(
    "users/me",
    async (body, thunkAPI) => {
        try {
            return (await http.put(`/api/users/me`, body)).data;
        } catch (err) {
            return thunkAPI.rejectWithValue(
                err.response.data.message || err.message
            );
        }
    }
);

export const checkoutCart = createAsyncThunk(
    "cart/checkout",
    async (body, thunkAPI) => {
        try {
            return (await http.post(`/api/cart/checkout`, body)).data;
        } catch (err) {
            return thunkAPI.rejectWithValue(
                err.response.data.message || err.message
            );
        }
    }
);

